import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
  standalone: false,
})
export class InfoDialogComponent {
  lines: string[];
  title: string;

  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InfoDialogData,
  ) {
    switch (data.messsage) {
      case MESSAGE_ENUM.CAT_RANK_EXTERNAL:
        this.lines = INFO_STATEMENTS.CAT_RANK_EXTERNAL;
        this.title = INFO_TITLES.CAT_RANK_TITLE;
        break;
      case MESSAGE_ENUM.CAT_RANK_INTERNAL:
        this.lines = INFO_STATEMENTS.CAT_RANK_INTERNAL;
        this.title = INFO_TITLES.CAT_RANK_TITLE;
        break;
      case MESSAGE_ENUM.CONFIDENCE_LABEL_EXTERNAL:
        this.lines = INFO_STATEMENTS.CONFIDENCE_LABEL_EXTERNAL;
        this.title = INFO_TITLES.CONFIDENCE_LABEL_TITLE;
        break;
      case MESSAGE_ENUM.CONFIDENCE_LABEL_INTERNAL:
        this.lines = INFO_STATEMENTS.CONFIDENCE_LABEL_INTERNAL;
        this.title = INFO_TITLES.CONFIDENCE_LABEL_TITLE;
        break;
      case MESSAGE_ENUM.DYNAMIC:
        this.lines = data.dynamicStatement;
        this.title = data.dynamicTitle;
        break;
    }
  }

  onOkClick(): void {
    this.dialogRef.close();
  }
}

export interface InfoDialogData {
  messsage: MESSAGE_ENUM;
  dynamicStatement?: string[];
  dynamicTitle?: string;
}
export enum MESSAGE_ENUM {
  CAT_RANK_INTERNAL,
  CAT_RANK_EXTERNAL,
  CONFIDENCE_LABEL_INTERNAL,
  CONFIDENCE_LABEL_EXTERNAL,
  DYNAMIC,
}

export class INFO_TITLES {
  public static CAT_RANK_TITLE = 'Categorization Rank Explanation';
  public static CONFIDENCE_LABEL_TITLE = 'Confidence Label Explanation';
}

export class INFO_STATEMENTS {
  public static CAT_RANK_INTERNAL = [
    'The Categorization Rank represents crosses that are supported by the greatest number of contributing sources (similar to Confidence Label), but with additional weighting based on alignment across several product categorization schemas (UNSPSC, PSC, and VSC).',
    'Crosses where both products are in the same UNSPSC, PSC, and VSC will therefore receive a greater Rank than crosses where one or more of those Categories differ.',
    'A Rank of 1 will always serve as the best available cross, dependent upon these factors.',
  ];
  public static CAT_RANK_EXTERNAL = [
    'The Categorization Rank represents crosses that are supported by the greatest number of contributing sources and additional weighting based on alignment across several product categorization schemas.',
    'Crosses where both products are in the same categorization schemas will therefore receive a greater Rank than crosses where one or more of those Categories differ.',
    'A Rank of 1 will always serve as the best available cross, dependent upon these factors.',
  ];
  public static CONFIDENCE_LABEL_INTERNAL = [
    'HIGH - Three or more unique sources have submitted the cross-reference.',
    'MEDIUM - Two unique sources have submitted the cross-reference.',
    'LOW - A single, unique source has submitted the cross-reference.',
    'NONE - Cross-reference was created by derivation or the cross-reference was made invalid.',
  ];
  public static CONFIDENCE_LABEL_EXTERNAL = [
    'HIGH - Three or more unique sources have submitted the cross-reference.',
    'MEDIUM - Two unique sources have submitted the cross-reference.',
    'LOW - A single, unique source has submitted the cross-reference.',
  ];
}
